<template>
  <el-dialog
    title="Özel Radius Veritabanı Bilgisi"
    :visible="Modal"
    center
    width="50%">
    <a @click="$emit('ModalOlayi', false)" class="ModalKapat"><i class="el-icon-close"></i></a>
    <el-alert
      title="Özel Radius Bilgileri"
      type="info"
      :closable="false"
      description="Kullanımınıza tahsis edilmiş özel bir Radius sunucusu varsa bilgileri doldurunuz.">
    </el-alert>
    <el-divider content-position="left">Radius Veritabanı Bilgileri</el-divider>
    <el-form :model="Form" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="Sunucu IP Adresi" prop="IP">
            <el-input v-model="Form.IP"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Sql Name" prop="Name">
            <el-input v-model="Form.Name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Sql User" prop="User">
            <el-input v-model="Form.User"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Sql Pass" prop="Pass">
            <el-input v-model="Form.Pass"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="medium" :disabled="lo" @click="Submit()" icon="el-icon-check">
        Kaydet
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: ['Modal', 'Bina_id'],
    data() {
      return {
        lo:false,
        Form: {
          IP: null,
          Name: null,
          User: null,
          Pass: null
        },
        FormHata: {
          IP: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Name: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          User: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Pass: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        }
      }
    },
    methods: {
      SayfaYukle() {
        this.$store.dispatch("Get", {path: '_radius/radius/' + this.Bina_id})
          .then(response => {
            if (response.Durum === 'OK') {
              if (response.Data) this.Form = response.Data

            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      },
      Submit() {
        this.$refs['Form'].validate((valid) => {
          if (valid) {
            this.lo = true;
            this.$store.dispatch("Post", {
              ...this.Form,
              path: '_radius/radius/' + this.Bina_id
            })
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.SayfaYukle();
                  this.$message.success("Radius Bilgileri kayıt edilmiştir.");
                  this.$message.success(response.Mesaj);
                } else {
                  this.$message.error(response.Mesaj);
                }
              })
          }
        })
      }
    },
    created() {
      this.SayfaYukle();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Internet/RadiusBilgiModal.vue